<template>
  <div class="home">
    <pop />
    <!-- <ripples /> -->
    <div class="swipe-box" v-if="isPc">
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      >
      </video-player>
      <!-- <div class="bg"></div> -->
    </div>
    <div class="swipe-box" v-else>
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions2"
      >
      </video-player>
      <!-- <div class="bg"></div> -->
    </div>
    <div class="section">
      <img src="@/assets/images/info-bg.png" class="bg-img" />
      <div class="information">
        <h2>冠龙节能，关注民生</h2>
        <router-link :to="{ path: '/about' }">
          <div class="more justify-center items-center little_hand">
            了解冠龙
            <!-- <img src="@/assets/images/menu.png" /> -->
            <svg-icon icon-class="direction"></svg-icon>
          </div>
        </router-link>
        <p class="desc">
          上海冠龙阀门节能设备股份有限公司成立于1991年，是国内一家著名的以研发制造给排水阀门、工业阀门及其自动控制系统和环保设备的港澳台投资企业。2022年4月，公司在创业板成功上市。公司主要从事节水阀门的研发、设计、生产和销售，主要产品包括蝶阀、闸阀、控制阀、止回阀等阀门产品及其他配套产品，主要应用于城镇给排水、水利和工业等下游领域。
        </p>
        <div class="nums justify-around items-center">
          <div
            class="nums-item flex-col items-center little_hand"
            v-for="(item, index) in numsArr"
            :key="index"
          >
            <router-link
              class="flex-col items-center"
              :to="{ path: item.pageName }"
            >
              <h3>{{ item.num }}</h3>
              <span>{{ item.name }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-black-bg">
      <div class="products">
        <canvas id="canvas"></canvas>
        <div class="products-box flex-row">
          <div class="products-menu flex-col" v-if="isPc">
            <div v-for="(item, index) in typeListRes" :key="item.prodTypeId">
              <div
                :class="[
                  'products-menu-item',
                  'items-center',
                  'little_hand',
                  { active: index == activeProduct },
                ]"
                @click="changeProducts(index)"
              >
                <div class="line"></div>
                <h3>{{ item.prodTypeName }}</h3>
                <div
                  class="more items-center little_hand"
                  v-if="index == activeProduct"
                >
                  <svg-icon icon-class="arrow"></svg-icon>
                  <svg-icon icon-class="arrow"></svg-icon>
                </div>
              </div>
            </div>
          </div>
          <div
            class="products-mobile-menu items-center"
            v-if="!isPc"
            @click="drawer = true"
          >
            <h3>切换产品系列</h3>
            <span class="items-center">
              <svg-icon className="icon1" icon-class="arrow"></svg-icon>
              <svg-icon className="icon1 icon2" icon-class="arrow"></svg-icon>
            </span>
          </div>
          <el-drawer
            title=""
            append-to-body
            :visible.sync="drawer"
            :direction="direction"
            class="products-menu"
          >
            <div v-for="(item, index) in typeListRes" :key="item.prodTypeId">
              <div
                :class="[
                  'products-menu-item',
                  'items-center',
                  'little_hand',
                  { active: index == activeProduct },
                ]"
                @click="changeProducts(index)"
              >
                <div class="line"></div>
                <h3>{{ item.prodTypeName }}</h3>
                <div
                  class="more items-center little_hand"
                  v-if="index == activeProduct"
                >
                  <svg-icon icon-class="arrow"></svg-icon>
                  <svg-icon icon-class="arrow"></svg-icon>
                </div>
              </div>
            </div>
          </el-drawer>
          <div class="products-con">
            <div class="title items-center justify-between">
              <div class="name items-end">
                <svg-icon className="icon1" icon-class="square"></svg-icon>
                <svg-icon className="icon2" icon-class="square"></svg-icon>
                <h2 v-if="typeListRes[activeProduct]">
                  <span>{{ typeListRes[activeProduct].prodTypeName }}</span>
                  <div class="square"></div>
                </h2>
              </div>
              <router-link :to="{ path: '/products' }">
                <div class="more items-center little_hand">
                  产品列表
                  <svg-icon icon-class="direction"></svg-icon>
                </div>
              </router-link>
            </div>
            <div class="desc" v-if="typeListRes[activeProduct]">
              {{ typeListRes[activeProduct].prodTypeDescrip }}
              <!-- 水力控制阀是一个总称，由一只主阀及其外装之针阀、向导阀等组合而成的一类自动控制阀。水力控制阀的工作状态一般呈常用状态、常开状态、浮动状态，主要依靠主阀与针阀或导阀之间调节来进行控制水流状态。 -->
            </div>
            <h3 v-if="prodListRes.length > 0">代表产品</h3>
            <el-row :gutter="isPc ? 16 : 12">
              <el-col
                :span="isPc ? 8 : 12"
                v-for="item in prodListRes"
                :key="item.prodId"
              >
                <div
                  class="products-info little_hand"
                  @click="toProductDetails(item.prodId)"
                >
                  <img :src="item.prodImage" />
                  <h4>{{ item.prodName }}</h4>
                  <!-- <span>100C SERIES</span> -->
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="project-case">
        <div class="column-title">
          <h2>工程案例</h2>
          <p>每个成功案例都是我们给予保障</p>
        </div>
        <el-row :gutter="20">
          <el-col
            :span="isPc ? 8 : 24"
            v-for="item in cases"
            :key="item.comRelatedId"
          >
            <div
              class="project-info little_hand"
              @click="toCaseDetails(item.comRelatedId, item.url)"
            >
              <img :src="item.image" />
              <h4 class="items-end">{{ item.title }}</h4>
              <div class="hover-info flex-col">
                <h5 class="items-end">{{ item.comRelatedDescrip }}</h5>
                <svg-icon icon-class="direction"></svg-icon>
              </div>
            </div>
          </el-col>
        </el-row>
        <router-link :to="{ path: '/cases' }">
          <div class="more items-center justify-end little_hand">
            更多案例
            <svg-icon icon-class="direction"></svg-icon>
          </div>
        </router-link>
      </div>
      <div class="section flex-row">
        <div class="white-bg"></div>
        <div class="news-center flex-row">
          <div class="news-title flex-col justify-between">
            <div class="column-title">
              <h2>新闻中心</h2>
              <p>点点滴滴汇聚于冠龙</p>
            </div>
            <router-link :to="{ path: '/news' }" v-if="isPc">
              <div class="more items-center little_hand">
                更多新闻
                <svg-icon icon-class="direction"></svg-icon>
              </div>
            </router-link>
          </div>
          <div class="news-lists">
            <swiper
              type="4"
              :newsSwiperRes="newsSwiperRes"
              v-if="isPc"
            ></swiper>
            <div
              v-if="!isPc"
              class="news-lists-item"
              v-for="item in newsSwiperRes"
              :key="item.newsId"
              @click="toDetails(item.newsId, item.url)"
            >
              <img :src="item.newsImage" />
              <h3>{{ item.newsTitle }}</h3>
              <time>{{ $dayjs(item.releaseTime||item.createTime).format("YYYY-MM-DD") }}</time>
            </div>
            <router-link :to="{ path: '/news' }" v-if="!isPc">
              <div class="more items-center justify-center little_hand">
                更多新闻
                <svg-icon icon-class="direction"></svg-icon>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="contact-ir flex-row">
      <router-link :to="{ path: '/contact' }">
        <div class="contact little_hand">
          <img src="@/assets/images/contact.png" class="bg" />
          <div class="flex-col justify-center">
            <h3>联系我们</h3>
            <p>全国各地办事处联系方式 <br />随时沟通</p>
            <svg-icon icon-class="direction"></svg-icon>
          </div>
        </div>
      </router-link>
      <a href="https://ir.p5w.net/c/301151.shtml">
        <div class="flex-col contact little_hand">
          <img src="@/assets/images/ir.png" class="bg" />
          <div class="flex-col justify-center">
            <h3>投资者关系</h3>
            <p>上海冠龙阀门节能设备股份有限公司 <br />投资者关系互动平台</p>
            <svg-icon icon-class="direction"></svg-icon>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import pop from "../common/pop.vue";
import Swiper from "../common/swiper.vue";
import { animation } from "@/utils/home-animation";
import { mapState } from "vuex";
// import ripples from "../common/ripples.vue"
import videojs from "video.js";
import "vue-video-player/src/custom-theme.css";
// 根据官方文档配置发现没有效果
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import { getTypeList, getProdList } from "@/assets/api/products.js";
import { getRelatedByCase } from "@/assets/api/about.js";
import { getNewsList } from "@/assets/api/news.js";

export default {
  name: "index",
  components: {
    Swiper,
    pop,
    videoPlayer,
    // ripples
  },
  data() {
    return {
      playerOptions: {
        // playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: true, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        // aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 类型
            src: "http://wz.karon-valve.com/video/publicity-cn.mp4", // url地址
          },
        ],
        poster: require("@/assets/images/home.png"), // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      },
      playerOptions2: {
        // playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: true, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        // aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 类型
            src: "http://wz.karon-valve.com/video/publicity-cn.mp4", // url地址
          },
        ],
        poster: require("@/assets/images/home-mobile.png"), // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      },
      numsArr: [
        {
          num: "6000+",
          name: "产品数量",
          pageName: "/products",
        },
        {
          num: "30+",
          name: "办事处",
          pageName: "/contact",
        },
        {
          num: "2022",
          name: "上市",
          pageName: "/about",
        },
        {
          num: "100+",
          name: "专利",
          pageName: "/about?type=qualification",
        },
        {
          num: "30+",
          name: "各类标准",
          pageName: "/about?type=detectability",
        },
      ],
      activeProduct: 0,
      typeListRes: [],
      prodListRes: [],
      cases: [],
      newsSwiperRes: [],
      drawer: false,
      direction: "rtl",
    };
  },
  computed: {
    ...mapState(["isPc"]),
  },
  created() {
    getTypeList({
      orderByColumn: "orderNum",
      isAsc: "desc",
      pageNum: 1,
      pageSize: 100,
    }).then((res) => {
      // console.log(res.data);
      this.typeListRes = res.data.data.rows;
      // this.activeType = this.typeListRes[0].prodTypeId;
      this.init();
    });
    getRelatedByCase({
      orderByColumn: "orderNum",
      isAsc: "desc",
      pageNum: 1,
      pageSize: 3,
    }).then((res) => {
      // console.log(res.data);
      this.cases = res.data.data.rows.map((item) => {
        item.image = !/^http/.test(item.image)
          ? this.$imgUrl + item.image
          : item.image;
        return item;
      });
    });
    getNewsList({
      orderByColumn: "releaseTime",
      isAsc: "desc",
      pageNum: 1,
      pageSize: 3,
      slideshow: 0,
    }).then((res) => {
      // console.log(res.data);
      this.newsSwiperRes = res.data.rows.map((item) => {
        item.newsImage = !/^http/.test(item.newsImage)
          ? this.$imgUrl + item.newsImage
          : item.newsImage;
        return item;
      });
    });
  },

  mounted() {
    animation();
  },

  methods: {
    changeProducts(index) {
      this.activeProduct = index;
      this.init();
      this.drawer = false;
    },
    init() {
      getProdList({
        orderByColumn: "orderNum",
        isAsc: "desc",
        prodTypeId: this.typeListRes[this.activeProduct].prodTypeId,
        pageNum: 1,
        pageSize: 6,
      }).then((res) => {
        // console.log(res.data);
        this.prodListRes = res.data.data.rows.map((item) => {
          item.prodImage = item.prodImage ? item.prodImage.split(",") : [];
          item.prodImage = !/^http/.test(item.prodImage[0])
            ? this.$imgUrl + item.prodImage[0]
            : item.prodImage[0];
          return item;
        });
      });
    },
    toProductDetails(prodId) {
      this.$router.push({
        path: `/products-details/${prodId}`,
      });
    },
    toDetails(newsId, url) {
      if (url) {
        window.open(url, "_blank");
      } else {
        this.$router.push({
          path: `/news-details/${newsId}`,
        });
      }
    },
    toCaseDetails(comRelatedId, url) {
      if (url) {
        window.open(url, "_blank");
      } else {
        this.$router.push({
          path: `/case-details/${comRelatedId}`,
        });
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.swipe-box {
  position: relative;
  .bg {
    width: 100%;
    height: 80px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
    opacity: 0.64;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 99;
  }
}
.more {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  color: #005bac;
  letter-spacing: 0;
  font-weight: 400;
  .svg-icon {
    width: 32px;
    height: 16px;
    margin-left: 8px;
  }
}
.section {
  padding: 100px 0;
  position: relative;
  .bg-img {
    position: absolute;
    z-index: 9;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    padding: 53px 40px 32px;
    background: #fff;
  }
  .column-title {
    h2 {
      font-family: MicrosoftYaHei-Bold;
      font-size: 36px;
      color: #2c2c2e;
      letter-spacing: 0;
      text-align: center;
      font-weight: 700;
      margin-bottom: 8px;
    }

    p {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #636366;
      letter-spacing: 0;
      text-align: center;
      line-height: 24px;
      font-weight: 400;
    }
  }
}
.section-black-bg {
  background: #121212;
  #canvas {
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 9;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .products-box {
    width: 1000px;
    margin: auto;
    position: relative;
    z-index: 10;
    .products-menu {
      margin-right: 13%;
      .products-menu-item {
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: rgba($color: #fff, $alpha: 1);
        letter-spacing: 0;
        font-weight: 400;
        padding: 8px 0;
        .line {
          width: 24px;
          height: 1px;
          background: rgba($color: #fff, $alpha: 1);
          margin-right: 8px;
        }
      }
      // .products-menu-item:hover {
      //   h3 {
      //     font-weight: 700;
      //   }
      //   color: #005bac;
      //   .line {
      //     width: 64px;
      //     height: 2px;
      //     background: #005bac;
      //   }
      //   .more {
      //     .svg-icon {
      //       width: 16px;
      //       height: 16px;
      //     }
      //     .svg-icon:last-child {
      //       margin-left: -8px;
      //     }
      //     margin-left: 8px;
      //   }
      // }
      .active {
        h3 {
          font-weight: 700;
        }
        color: #005bac;
        .line {
          width: 64px;
          height: 2px;
          background: #005bac;
        }
        .more {
          .svg-icon {
            width: 16px;
            height: 16px;
          }
          .svg-icon:last-child {
            margin-left: -8px;
          }
          margin-left: 8px;
        }
      }
    }
    .products-con {
      flex: 1;
      .title {
        .name {
          .icon1 {
            width: 20px;
            height: 36px;
            color: #005bac;
          }
          .icon2 {
            width: 20px;
            height: 36px;
            color: rgba($color: #005bac, $alpha: 0.6);
            margin-left: -4px;
          }
          h2 {
            font-size: 36px;
            font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
            font-weight: bold;
            color: #fff;
            line-height: 47px;
            position: relative;
            padding: 8px 20px;
            box-sizing: border-box;
            span {
              position: relative;
              z-index: 10;
            }
            .square {
              width: 100%;
              height: 36px;
              transform: skew(-13deg);
              background-color: rgba($color: #005bac, $alpha: 0.4);
              position: absolute;
              left: 0;
              bottom: 0;
            }
            .svg-icon {
              width: 100%;
              height: 36px;
              color: rgba($color: #005bac, $alpha: 0.4);
              object-fit: cover;
              position: absolute;
              left: 0;
              bottom: 0;
            }
          }
        }
        h2 {
          font-family: MicrosoftYaHei-Bold;
          font-size: 36px;
          color: #ffffff;
          letter-spacing: 0;
          font-weight: 700;
        }
        .more {
          font-family: MicrosoftYaHei;
          font-size: 16px;
          color: #fff;
          // color: #005bac;
          letter-spacing: 0;
          font-weight: 400;
          .svg-icon {
            width: 32px;
            height: 16px;
            margin-left: 8px;
          }
        }
      }
      .desc {
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 28px;
        font-weight: 400;
        margin-top: 16px;
        margin-bottom: 40px;
      }
      h3 {
        font-family: MicrosoftYaHei-Bold;
        font-size: 18px;
        color: #ffffff;
        letter-spacing: 0;
        font-weight: 700;
        margin-bottom: 16px;
      }
      .products-info {
        img {
          width: 100%;
          height: 240px;
          object-fit: contain;
          background: rgba(255, 255, 255, 0.04);
          border-bottom: 2px solid #005bac;
        }
        h4 {
          font-family: MicrosoftYaHei-Bold;
          font-size: 16px;
          color: #ffffff;
          letter-spacing: 0;
          font-weight: 700;
          margin-top: 8px;
          margin-bottom: 4px;
          height: 44px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break: break-all;
        }
        span {
          font-family: Arial-ItalicMT;
          font-size: 12px;
          color: rgba($color: #fff, $alpha: 0.4);
          letter-spacing: 0;
          font-weight: 400;
        }
      }
    }
  }
}
.information {
  width: 1000px;
  margin: auto;
  position: relative;
  z-index: 10;
  h2 {
    font-size: 36px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #2c2c2e;
    line-height: 47px;
    text-align: center;
  }
  .more {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #005bac;
    letter-spacing: 0;
    font-weight: 400;
    line-height: 19px;
    margin: 16px 0;
    .svg-icon {
      width: 32px;
      height: 16px;
      margin-left: 8px;
    }
  }
  .desc {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #2c2c2e;
    line-height: 30px;
  }
  .nums {
    margin-top: 40px;
    .nums-item {
      h3 {
        font-family: MicrosoftYaHei-Bold;
        font-size: 36px;
        color: #005bac;
        letter-spacing: 0;
        text-align: center;
        font-weight: 700;
        line-height: 47px;
      }
      span {
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #005bac;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;

        line-height: 21px;
        margin-top: 16px;
      }
    }
  }
}
.project-case {
  width: 1000px;
  margin: auto;
  position: relative;
  z-index: 10;
  .column-title {
    margin-bottom: 24px;
  }
  .project-info {
    position: relative;
    overflow: hidden;
    img {
      width: 100%;
      height: 420px;
      object-fit: cover;
    }
    h4 {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 210px;
      background-image: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.64) 100%
      );
      font-family: MicrosoftYaHei-Bold;
      font-size: 24px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 36px;
      font-weight: 700;
      border-bottom: 8px solid #005bac;
      padding: 20px;
    }
    .hover-info {
      position: absolute;
      transition: all 0.5s;
      width: 100%;
      // height: 160px;
      background: #005bac;
      padding: 20px;
      color: #ffffff;
      h5 {
        font-family: MicrosoftYaHei-Bold;
        font-size: 24px;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 36px;
        font-weight: 700;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
      .svg-icon {
        width: 48px;
        height: 24px;
        margin-top: 24px;
      }
    }
  }
  .project-info:hover {
    .hover-info {
      bottom: 0;
    }
  }
  .more {
    margin-top: 40px;
    padding-bottom: 100px;
    border-bottom: 1px solid #e5e5ea;
  }
}
.white-bg {
  position: relative;
  background: #fff;
  z-index: 999;
}
.news-center {
  width: 1000px;
  margin: auto;
  position: relative;
  z-index: 10;

  .news-title {
    min-width: 150px;
    position: relative;
    background: #fff;
    z-index: 999;
    padding-right: 125px;
    box-sizing: content-box;
    .more {
      padding-bottom: 50px;
    }
  }
  .news-lists {
    flex: 1;
    width: 100%;
  }
}

.contact-ir {
  height: 400px;
  a {
    display: block;
    width: 50%;
  }
  .contact {
    flex: 1;
    position: relative;
    .bg {
      width: 100%;
      height: 400px;
      opacity: 0.95;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9;
    }
    div {
      position: relative;
      z-index: 10;
      padding-left: 220px;
      box-sizing: content-box;
      width: 180px;
      height: 400px;
    }
    h3 {
      font-family: MicrosoftYaHei-Bold;
      font-size: 36px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 700;
      line-height: 47px;
      margin-bottom: 20px;
      white-space: nowrap;
    }
    p {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: rgba($color: #fff, $alpha: 0.8);
      line-height: 28px;
      padding-bottom: 44px;
      white-space: nowrap;
    }
    .svg-icon {
      width: 56px;
      height: 23px;
      color: #ffffff;
    }
  }
}
@media screen and (max-width: 768px) {
  .more {
    font-size: 14px;
    .svg-icon {
      width: 24px;
      height: 13px;
      margin-left: 4px;
    }
  }
  .section {
    padding: 60px 0;
    .bg-img {
      object-fit: cover;
      padding: 0;
    }
    .column-title {
      h2 {
        font-size: 24px;
      }
      p {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
  .information {
    width: 100%;
    padding: 0 20px;
    h2 {
      font-size: 24px;
      line-height: 31px;
    }
    .more {
      font-size: 14px;
      .svg-icon {
        width: 24px;
        height: 12px;
        margin-left: 4px;
      }
    }
    .desc {
      font-size: 14px;
      line-height: 24px;
    }
    .nums {
      flex-wrap: wrap;
      .nums-item {
        flex: 0 0 30%;
        margin-bottom: 40px;
        h3 {
          font-size: 24px;
          line-height: 31px;
        }
        span {
          font-size: 14px;
          line-height: 19px;
          margin-top: 8px;
        }
      }
      .nums-item:nth-child(4n) {
        margin-bottom: 0;
      }
      .nums-item:nth-child(5n) {
        margin-bottom: 0;
      }
    }
  }
  .section-black-bg {
    .products-box {
      width: 100%;
      padding: 0 20px;
      flex-direction: column;
      .products-mobile-menu {
        margin-bottom: 8px;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: #005bac;
        line-height: 28px;
        h3 {
          margin-right: 4px;
        }
        .icon1 {
          width: 16px;
          height: 16px;
        }
        .icon2 {
          margin-left: -8px;
        }
      }
      .products-con {
        flex: 1;
        .title {
          .name {
            .icon1 {
              width: 16px;
              height: 28px;
            }
            .icon2 {
              width: 16px;
              height: 28px;
              margin-left: -2px;
            }
            h2 {
              font-size: 24px;
              line-height: 31px;
              padding: 6px 14px;
              .square {
                width: 100%;
                height: 28px;
                transform: skew(-13deg);
              }
            }
          }
          .more {
            font-size: 14px;
            .svg-icon {
              width: 24px;
              height: 12px;
              margin-left: 4px;
            }
          }
        }
        .desc {
          font-size: 14px;
          line-height: 24px;
        }
        h3 {
          font-size: 16px;
        }
        .products-info {
          margin-bottom: 12px;
          img {
            width: 100%;
            height: 203px;
            object-fit: contain;
          }
          h4 {
            font-size: 14px;
          }
        }
      }
    }
  }
  .project-case {
    width: 100%;
    padding: 0 20px;
    .project-info {
      margin-bottom: 16px;
      img {
        height: 456px;
      }
      h4 {
        height: 228px;
        font-size: 20px;
        line-height: 30px;
      }
      .hover-info {
        position: absolute;
        transition: all 0.5s;
        width: 100%;
        // height: 160px;
        background: #005bac;
        padding: 20px;
        color: #ffffff;
        h5 {
          font-family: MicrosoftYaHei-Bold;
          font-size: 24px;
          color: #ffffff;
          letter-spacing: 0;
          line-height: 36px;
          font-weight: 700;
        }
        .svg-icon {
          width: 48px;
          height: 24px;
          margin-top: 24px;
        }
      }
    }
    .project-info:hover {
      .hover-info {
        bottom: 0;
      }
    }
    .more {
      justify-content: center;
      margin-top: 8px;
      padding-bottom: 60px;
    }
  }
  .news-center {
    width: 100%;
    padding: 0 20px;
    flex-direction: column;
    .news-title {
      width: 100%;
      padding-right: 0;
      .more {
        padding-bottom: 50px;
      }
    }
    .news-lists {
      flex: 1;
      width: 100%;
      margin-top: 24px;
      .news-lists-item {
        margin-bottom: 16px;
        img {
          width: 100%;
          height: 214px;
          object-fit: cover;
          margin-bottom: 8px;
        }
        h3 {
          font-size: 16px;
          font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
          font-weight: bold;
          color: #2c2c2e;
          line-height: 21px;
          margin-bottom: 8px;
        }
        time {
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #aeaeb2;
          line-height: 19px;
        }
      }
    }
  }
  .contact-ir {
    flex-direction: column;
    height: auto;
    a {
      display: block;
      width: 100%;
    }
    .contact {
      flex: 1;
      position: relative;
      .bg {
        width: 100%;
        height: 100%;
        opacity: 0.95;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 9;
      }
      div {
        padding-left: 60px;
        width: auto;
        height: 326px;
      }
      h3 {
        font-size: 24px;
        line-height: 31px;
        margin-bottom: 12px;
      }
      p {
        font-size: 14px;
        line-height: 24px;
        padding-bottom: 40px;
      }
      .svg-icon {
        width: 40px;
        height: 20px;
      }
    }
  }
  .products-menu {
    .products-menu-item {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #636366;
      letter-spacing: 0;
      font-weight: 400;
      padding: 12px 24px;
      .line {
        width: 24px;
        height: 1px;
        background: #636366;
        margin-right: 8px;
      }
    }
    .active {
      h3 {
        font-weight: 700;
        white-space: nowrap;
      }
      color: #005bac;
      .line {
        width: 64px;
        height: 2px;
        background: #005bac;
      }
      .more {
        .svg-icon {
          width: 16px;
          height: 16px;
        }
        .svg-icon:last-child {
          margin-left: -8px;
        }
      }
    }
  }
}
</style>
<style>
.vjs-poster {
  background-size: cover;
}
.products-menu .el-drawer {
  width: 62% !important;
}
.vjs-custom-skin > .video-js .vjs-play-progress:before {
  top: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/index/index.vue